import { c as _c } from "react-compiler-runtime";
import React from "react";
import { DatePicker } from "./DatePicker.js";
import * as styles from "./DateRange.css.js";
import { FCTextFieldContext } from "./TextFieldContext.js";
import useI18n from "./internal/useI18n.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const forwardedKeys = ["value", "defaultValue", "onChange", "name", "loadingState", "onFocus", "onBlur"];
function extractDatePickerProps(props, prefix) {
  const result = {};
  for (const key of forwardedKeys) {
    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
    const prefixedKey = `${prefix}${capitalizedKey}`;
    if (prefixedKey in props) {
      // @ts-expect-error - This is safe because we're checking if the key exists
      result[key] = props[prefixedKey];
    }
  }
  return result;
}
const BaseDateRange = (t0, ref) => {
  const $ = _c(20);
  const {
    left,
    ...props
  } = t0;
  const i18n = useI18n();
  const fcLabelProps = React.useContext(FCTextFieldContext);
  const fromProps = extractDatePickerProps(props, "from");
  const toProps = extractDatePickerProps(props, "to");
  const label = fcLabelProps.label ?? "";
  if (label.length === 0 && process.env.NODE_ENV !== "production") {
    console.warn("DateRange component is missing a label. This may cause accessibility issues.");
  }
  let t1;
  if ($[0] !== left) {
    t1 = /*#__PURE__*/_jsx("div", {
      className: styles.left,
      children: left
    });
    $[0] = left;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== i18n || $[3] !== label) {
    t2 = i18n.format("dateRangeFrom", {
      label
    });
    $[2] = i18n;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== fromProps || $[6] !== t2) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: styles.from,
      children: /*#__PURE__*/_jsx(DatePicker, {
        ...fromProps,
        slot: "from",
        "aria-label": t2
      })
    });
    $[5] = fromProps;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx("div", {
      className: styles.separator,
      children: " - "
    });
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== i18n || $[10] !== label) {
    t5 = i18n.format("dateRangeTo", {
      label
    });
    $[9] = i18n;
    $[10] = label;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5 || $[13] !== toProps) {
    t6 = /*#__PURE__*/_jsx("div", {
      className: styles.to,
      children: /*#__PURE__*/_jsx(DatePicker, {
        ...toProps,
        skipLabelClickListener: true,
        slot: "to",
        "aria-label": t5
      })
    });
    $[12] = t5;
    $[13] = toProps;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== ref || $[16] !== t1 || $[17] !== t3 || $[18] !== t6) {
    t7 = /*#__PURE__*/_jsxs("div", {
      ref: ref,
      className: styles.content,
      children: [t1, t3, t4, t6]
    });
    $[15] = ref;
    $[16] = t1;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export const DateRange = /*#__PURE__*/React.forwardRef(BaseDateRange);
//# sourceMappingURL=DateRange.js.map